import "./style.scss";
import { useState } from "react";
import {
  postPrescriptionTemplate,
  postPatientReport,
  fetchPatientDetailsUuid,
  coupleIdChecker,
  postAppointment,
} from "../../Redux/Thunk/Actions";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import headerimage from "../../assets/images/ascas.svg";
import Headers from "../../Components/Header/Headers";
import { PrescriptionFooter } from "../../Components/Prescription Footer/PrescriptionFooter";

export default function DeliveryAdmissionFormormTemplate(props) {
  const [valueChange, setvalueChange] = useState({});
  const [show, setshow] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const patientId = useSelector((state) => state.counter.patientid);

  const [patientOne_UUId, setPatientOne_UUId] = useState("");
  const [appointmentData, setAppointmentData] = useState({
    p_uhid: "",
    name: "",
    date: "",
    time: "",
    status: "Not Visited",
    notes: "",
    patient_id: "",
    });

  const handleChange = (e) => {
    // const { name, value } = e.target;
    // setvalueChange({ ...valueChange, [name]: value });
    var text = e.target.value;

    if (e.target.name === "patientId1") {
      if (e.target.value.length === 10 && e.target.value.charAt(0) === "A") {
        const fetchData = async () => {
          const payload = {
            p_uhid: e.target.value,
          };
          props.loaderchange("true");
          const addPatient = fetchPatientDetailsUuid(payload);
          const response = await dispatch(addPatient);
          if (response.payload?.status?.code === 200) {
            const data = response.payload.data.data[0];
            const namePat =
              data?.titles + " " + data?.first_name + " " + data?.last_name;
            if (e.target.name === "patientId1") {
              setPatientOne_UUId(data?.id);
              setvalueChange({
                ...valueChange,
                patientName1: namePat,
                age1: data?.age,
                gender1: data?.gender,
                patientId1: text,
              });
            }
            props.loaderchange("false");
          } else {
            props.loaderchange("false");
            props.popupalert("true");
            props.popuptext("Network went wrong, Please try after some time.");
            setTimeout(() => {
              props.popupalert("false");
            }, 2000);
          }
          return;
        };

        fetchData();
      } else {
        if (e.target.name === "patientId1") {
          setvalueChange({
            ...valueChange,
            patientId1: e.target.value,
          });
        }
      }
    } else {
      console.log("Going in");
      setvalueChange({ ...valueChange, [e.target.name]: e.target.value });
      if (e.target.name === "nextappointment") {
        const dateTime = e.target.value.split("T");
        setAppointmentData({
        ...appointmentData,
        date: dateTime[0],
        time: dateTime[1],
        p_uhid: props.patientsData.p_uhid,
        name: `${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`,
        status: "Not Visited",
        notes: "Booking Visit",
        patient_id: patientId,
        });
        }
        
    }
  };

  const handlesubmit = () => {
    props.loaderchange("true");
    try {
      if (
        props.patientsData.id !== "" &&
        props.patientsData.p_uhid !== "" &&
        props.patientsData.p_uhid.length === 10
      ) {
        setshow(true);
        // Set timeout to handle async report creation
        setTimeout(async () => {
          // Get HTML payload
          const htmlPayload = document.getElementById("prescriptionReportWrap").innerHTML;

          // Prepare payload for creating report
          const payload = {
            payload: {
              prescription_template: htmlPayload,
              patient_id: patientId,
              description: "",
              template_type: "Delivery Admission From",
            },
          };

          const createNewAppointment = async () => {
            console.log(appointmentData);
            await dispatch(postAppointment(appointmentData));
            };
            createNewAppointment();
          // Dispatch action to create patient report
          props.loaderchange(true);
          const patentDetails = postPrescriptionTemplate(payload);
          const response = await dispatch(patentDetails);
          if (response?.payload?.status?.code === 200) {
            props.loaderchange(false);
            navigate("/PatientView");
            Swal.fire({
              title: "Successful.",
              text: "Record added successful.",
              icon: "success",
              showConfirmButton: false,
              timer: 1500,
            });
            props.loaderchange("false");
          } else {
            props.loaderchange("false");
            props.popupalert("true");
            props.popuptext("Network went wrong, Please try after some time.");
            // props.popuptext(response?.status?.message);
            setTimeout(() => {
              props.popupalert("false");
            }, 2000);
          }
        }, 3000);
      } else {
        // Show error message for invalid patient ids
        Swal.fire({
          title: "Error.",
          text: "Please enter valid patient id.",
          icon: "error",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };
  const renderReportfield = (name, value, options = {}) => {
    const { styleSec = {}, styleLabel = {}, styleSpan = {} } = options;

    return (
      <>
        <section
          style={{ ...styleSec, margin: "0 10px 10px 10px", display: "flex" }}
        >
          <label
            style={{
              ...styleLabel,
              fontWeight: "600",
              marginRight: "5px",
              width: "max-content",
            }}
          >
            {name}
          </label>
          <span style={styleSpan}>{value}</span>
        </section>
      </>
    );
  };

  const renderTableTD = (value, options = {}) => {
    const { style = { border: "1px solid black", textAlign: "center" } } =
      options;
    return <td style={style}>{value}</td>;
  };
  const renderTableTH = (value, options = {}) => {
    const {
      style = { border: "1px solid black", textAlign: "center" },
      colspans = 1,
    } = options;
    return (
      <th colSpan={colspans} style={style}>
        {value}
      </th>
    );
  };

  return (
    <>
      <div id="reportcreate">
        <div className="outer">
          <div
            className=""
            style={{ width: "100%", display: "block" }}
            id="patientInfo1"
          >
            <div style={{ width: "100%" }}>
              <img
                className="header_image"
                src={headerimage}
                style={{
                  // width: "100%", height: "25vh", maxHeight: show ? "100px" : "400px"

                  width: "100%",
                  margin: "0 auto",
                }}
              ></img>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                justifyContent: "center",
                gap: "3px",
                backgroundColor: "#f7f7f7 ",
                borderRadius: "6px",
                padding: "16px 8px 16px 8px",
                gap: "3px",
              }}
            >
              {/* Patient ID and Couple ID (Side by side) */}
              <div
                style={{ display: "flex", gap: "16px", alignItems: "center" }}
              >
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "125px 16px 250px",
                    alignItems: "center ",
                  }}
                >
                  <span style={{ fontWeight: 600 }}>Patient ID</span>
                  <span style={{ fontWeight: 600 }}>: </span>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    value={props.patientsData.p_uhid}
                    onChange={(e) => handleChange(e)}
                    name="patientId1"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                    }}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{props.patientsData.p_uhid}
                  </span>
                </div>
              </div>

              {/* Patient Name */}
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "125px 16px 250px",
                  alignItems: "center ",
                }}
              >
                <span style={{ fontWeight: 600 }}>Patient Name</span>
                <span style={{ fontWeight: 600 }}>: </span>
                <input
                  type="text"
                  className={`createTime ${show ? "hide" : "show"}`}
                  onChange={(e) => handleChange(e)}
                  value={`${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`}
                  name="patientName1"
                  style={{
                    border: "1px solid #ddd",
                    outline: "none",
                    padding: "10px",
                    color: "#000",
                  }}
                />
                <span
                  className={`input ${!show ? "hide" : "show"}`}
                  style={{ width: "100%" }}
                >
                  &nbsp;
                  {`${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`}
                </span>
              </div>
              {/* Gender and Blood Group (Side by side) */}
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "16px",
                }}
              >
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "125px 16px 250px",
                    alignItems: "center ",
                  }}
                >
                  <span style={{ fontWeight: 600 }}>Gender</span>
                  <span style={{ fontWeight: 600 }}>: </span>
                  <select
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    value={props.patientsData.gender}
                    name="gender1"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                      backgroundColor: "white",
                    }}
                  >
                    <option value="" disabled selected>
                      Select Gender
                    </option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                    <option value="Others">Others</option>
                    <option value="Decline to State">Decline to State</option>
                  </select>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{props.patientsData.gender}
                  </span>
                </div>
              </div>

              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "125px 16px 250px",
                  alignItems: "center ",
                }}
              >
                <span style={{ fontWeight: 600 }}>Age</span>
                <span style={{ fontWeight: 600 }}>: </span>
                <input
                  type="text"
                  className={`createTime ${show ? "hide" : "show"}`}
                  onChange={(e) => handleChange(e)}
                  value={props.patientsData.age}
                  name="age1"
                  style={{
                    border: "1px solid #ddd",
                    outline: "none",
                    padding: "10px",
                  }}
                />
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{props.patientsData.age}
                </span>
              </div>

              {/* <div
              style={{
                display: "grid",
                gridTemplateColumns: "125px 16px 250px",
                alignItems: "center",
                // paddingLeft: "25px",
              }}
            >
              <span style={{ fontWeight: 600 }}>Blood Group</span>
              <span style={{ fontWeight: 600 }}>: </span>
              <select
                className={`createTime ${show ? "hide" : "show"}`}
                onChange={(e) => handleChange(e)}
                name="bloodGroup1"
                value={valueChange.bloodGroup1}
                style={{
                  border: "1px solid #ddd",
                  outline: "none",
                  padding: "10px",
                  backgroundColor: "white",
                }}
              >
                <option value="" disabled selected>
                  Select Blood Group
                </option>
                <option value="A+">A+</option>
                <option value="A-">A-</option>
                <option value="B+">B+</option>
                <option value="B-">B-</option>
                <option value="AB+">AB+</option>
                <option value="AB-">AB-</option>
                <option value="O+">O+</option>
                <option value="O-">O-</option>
              </select>
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{valueChange.bloodGroup1}
              </span>
            </div> */}
            </div>
          </div>
          <h1>DELIVERY ADMISSION FORM</h1>
          <table className="table_1" border="1px" cellSpacing="0px">
            <tbody>
              <tr>
                <th>Date of admission</th>
                <td>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    type="date"
                    name="dateofadmission"
                    onChange={handleChange}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.dateofadmission}
                  </span>
                </td>
              </tr>
              <tr>
                <th> Procedure date and time</th>
                <td>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    type="datetime-local"
                    name="proceduredatetime"
                    onChange={handleChange}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;
                    {` ${valueChange?.proceduredatetime?.slice(
                      0,
                      10
                    )} , ${valueChange?.proceduredatetime?.slice(11)}`}
                  </span>
                </td>
              </tr>
              <tr>
                <th> Hospital</th>
                <td>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    name="hospital"
                    onChange={handleChange}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.hospital}
                  </span>
                </td>
              </tr>
              <tr>
                <th> Diagnosis</th>
                <td>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    name="diagnosis"
                    onChange={handleChange}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.diagnosis}
                  </span>
                </td>
              </tr>
              <tr>
                <th> GDM/HT/Thyroid/PIH</th>
                <td>
                  <select
                    className={`createTime ${show ? "hide" : "show"}`}
                    name="gdmhtthyroidpih"
                    onChange={handleChange}
                  >
                    <option value="" disabled selected>
                      Please Select...
                    </option>

                    <option value="GDM">GDM</option>
                    <option value="HT">HT</option>
                    <option value="Thyroid">Thyroid</option>
                    <option value="PIH">PIH</option>
                  </select>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.gdmhtthyroidpih}
                  </span>
                </td>
              </tr>
              <tr>
                <th> NICU/ICU NEEDED</th>
                <td>
                  <select
                    className={`createTime ${show ? "hide" : "show"}`}
                    name="nicuicuneeded"
                    onChange={handleChange}
                  >
                    <option value="" disabled selected>
                      Please Select...
                    </option>

                    <option value="NICU">NICU</option>
                    <option value="ICU">ICU</option>
                  </select>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.nicuicuneeded}
                  </span>
                </td>
              </tr>
              <tr>
                <th> Procedure</th>
                <td>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    name="procedure"
                    onChange={handleChange}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.procedure}
                  </span>
                </td>
              </tr>
              <tr>
                <th> Insurance</th>
                <td>
                  <select
                    className={`createTime ${show ? "hide" : "show"}`}
                    name="insurance"
                    onChange={handleChange}
                  >
                    <option value="" disabled selected>
                      Please Select...
                    </option>

                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.insurance}
                  </span>
                </td>
              </tr>
              <tr>
                <th> Financial counselling</th>
                <td>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    name="financialcounselling"
                    onChange={handleChange}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.financialcounselling}
                  </span>
                </td>
              </tr>
              <tr>
                <th> Pain releif discussed</th>
                <td>
                  <select
                    className={`createTime ${show ? "hide" : "show"}`}
                    name="painreliefdiscussed"
                    onChange={handleChange}
                  >
                    <option value="" disabled selected>
                      Please Select...
                    </option>

                    <option value="Epidural">Epidural</option>
                    <option value="Entonox">Entonox</option>
                  </select>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.painreliefdiscussed}
                  </span>
                </td>
              </tr>
              <tr>
                <th> Stem cell storage discussed</th>
                <td>
                  <select
                    className={`createTime ${show ? "hide" : "show"}`}
                    name="stemcellstoragediscussed"
                    onChange={handleChange}
                  >
                    <option value="" disabled selected>
                      Please Select...
                    </option>

                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.stemcellstoragediscussed}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
          <br />
          <br />
          <table className="table_2" border="1px" cellSpacing="0px">
            <tbody>
              <tr>
                <th> CHECKLIST</th>
                <td>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    name="checklist"
                    onChange={handleChange}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.checklist}
                  </span>
                </td>
              </tr>
              <tr>
                <th> Blood group</th>
                <td>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    name="bloodgroup"
                    onChange={handleChange}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.bloodgroup}
                  </span>
                </td>
              </tr>
              <tr>
                <th> HB/PCV/PLT</th>
                <td>
                  <select
                    className={`createTime ${show ? "hide" : "show"}`}
                    name="hbpcvplt"
                    onChange={handleChange}
                  >
                    <option value="" disabled selected>
                      Please Select...
                    </option>

                    <option value="HB">HB</option>
                    <option value="PCV">PCV</option>
                    <option value="PLT">PLT</option>
                  </select>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.hbpcvplt}
                  </span>
                </td>
              </tr>
              <tr>
                <th> TSH/FT4</th>
                <td>
                  <select
                    className={`createTime ${show ? "hide" : "show"}`}
                    name="tshft4"
                    onChange={handleChange}
                  >
                    <option value="" disabled selected>
                      Please Select...
                    </option>

                    <option value="TSH">TSH</option>
                    <option value="FT4">FT4</option>
                  </select>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.tshft4}
                  </span>
                </td>
              </tr>
              <tr>
                <th> RBS/HBA1C</th>
                <td>
                  <select
                    className={`createTime ${show ? "hide" : "show"}`}
                    name="rbsahba1c"
                    onChange={handleChange}
                  >
                    <option value="" disabled selected>
                      Please Select...
                    </option>

                    <option value="RBS">RBS</option>
                    <option value="HBA1C">HBA1C</option>
                  </select>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.rbsahba1c}
                  </span>
                </td>
              </tr>
              <tr>
                <th> UREA/CREAT</th>
                <td>
                  <select
                    className={`createTime ${show ? "hide" : "show"}`}
                    name="ureacreat"
                    onChange={handleChange}
                  >
                    <option value="" disabled selected>
                      Please Select...
                    </option>

                    <option value="UREA">UREA</option>
                    <option value="CREAT">CREAT</option>
                  </select>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.ureacreat}
                  </span>
                </td>
              </tr>
              <tr>
                <th> HIV/HBSAG/HCV/VDRL</th>
                <td>
                  <select
                    className={`createTime ${show ? "hide" : "show"}`}
                    name="hivhbsaghcvvdrl"
                    onChange={handleChange}
                  >
                    <option value="" disabled selected>
                      Please Select...
                    </option>

                    <option value="HIV">HIV</option>
                    <option value="HBSAG">HBSAG</option>
                    <option value="HCV">HCV</option>
                    <option value="VDRL">VDRL</option>
                  </select>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.hivhbsaghcvvdrl}
                  </span>
                </td>
              </tr>
              <tr>
                <th> ECG/ECHO</th>
                <td>
                  <select
                    className={`createTime ${show ? "hide" : "show"}`}
                    name="ecgecho"
                    onChange={handleChange}
                  >
                    <option value="" disabled selected>
                      Please Select...
                    </option>

                    <option value="ECG">ECG</option>
                    <option value="ECHO">ECHO</option>
                  </select>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.ecgecho}
                  </span>
                </td>
              </tr>
              <tr>
                <th> PICME</th>
                <td>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    name="picme"
                    onChange={handleChange}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.picme}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
          <br />
          <br />
          <div className="para">
            <ol>
              <li>
                Inj.Taxim 1g /&nbsp;&nbsp;&nbsp;&nbsp;Inj..Magnex forte 1.5g /
                inj.supacef 1.5gBefore incision
              </li>
              <li>Inj.Pan 40mg IV/ Inj.Emeset 4mg IV Before shifting</li>
              <li>Proctolytics enema needed/Not needed</li>
              <li>CTG on admission and before shifting to theatre</li>
              <li>Cross match blood- 1UNIT PRBCS Reserve/ On table</li>
              <li className="bold">Aadhar Card/ ID proof of patient </li>
            </ol>
          </div>
          {/* <p style={{ textAlign: "center", padding: "30px 10px" }}>
            x x x End Of Bill x x x
          </p> */}

<p style={{fontWeight:"600"}}>
NEXT APPOINTMENT -{" "}
<input
name="nextappointment"
onChange={handleChange}
type="datetime-local"
// type="date"
/>
</p>

          <div className={`Footer ${show ? "hide" : "show"}`}>
            <button onClick={handlesubmit} className="Button_Create">
              Add Report
            </button>
          </div>
        </div>
      </div>
      <div id="prescriptionReport">
        <div id="prescriptionReportWrap">
          <Headers />
          <p class="Dani"></p>
          <div
            className="patient"
            style={{
              border: "1px solid black",
              borderRadius: "10px",
              marginBottom: "10px",
            }}
          >
            <div
              className="nameToAgeContainer"
              style={{ display: "flex", marginBottom: "10px" }}
            >
              {renderReportfield(
                "Patient Name :",
                `${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`
              )}
              {renderReportfield("Patient ID :", props.patientsData.p_uhid)}
              {renderReportfield("Gender :", props.patientsData.gender)}
              {renderReportfield("Age :", props.patientsData.age)}
            </div>
          </div>
          <div>
            <h1 style={{ textAlign: "center" }}>DELIVERY ADMISSION FORM</h1>
          </div>
          <div>
            <table style={{ width: "100%", marginBottom: "10px" }}>
              <tbody>
                {[...Array(11)].map((_, i) => {
                  const Th = [
                    "Date of admission",
                    "Procedure date and time",
                    "Hospital",
                    "Diagnosis",
                    "GDM/HT/Thyroid/PIH",
                    "NICU/ICU NEEDED",
                    "Procedure",
                    "Insurance",
                    "Financial counselling",
                    "Pain releif discussed",
                    "Stem cell storage discussed",
                  ];
                  const Td = [
                    valueChange.dateofadmission,
                    valueChange.proceduredatetime,
                    valueChange.hospital,
                    valueChange.diagnosis,
                    valueChange.gdmhtthyroidpih,
                    valueChange.nicuicuneeded,
                    valueChange.procedure,
                    valueChange.insurance,
                    valueChange.financialcounselling,
                    valueChange.painreliefdiscussed,
                    valueChange.stemcellstoragediscussed,
                  ];
                  return (
                    <tr key={i}>
                      {renderTableTH(Th[i])}
                      {renderTableTD(Td[i])}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div>
            <table style={{ width: "100%", marginBottom: "10px" }}>
              <tbody>
                {[...Array(9)].map((_, i) => {
                  const Th = [
                    "CHECKLIST",
                    "Blood group",
                    "HB/PCV/PLT",
                    "TSH/FT4",
                    "RBS/HBA1C",
                    "UREA/CREAT",
                    "HIV/HBSAG/HCV/VDRL",
                    "ECG/ECHO",
                    "PICME",
                  ];
                  const Td = [
                    valueChange.checklist,
                    valueChange.bloodgroup,
                    valueChange.hbpcvplt,
                    valueChange.tshft4,
                    valueChange.rbsahba1c,
                    valueChange.ureacreat,
                    valueChange.hivhbsaghcvvdrl,
                    valueChange.ecgecho,
                    valueChange.picme,
                  ];
                  return (
                    <tr key={i}>
                      {renderTableTH(Th[i])}
                      {renderTableTD(Td[i])}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div>
            {[
              "Inj.Taxim 1g /    Inj..Magnex forte 1.5g / inj.supacef 1.5gBefore incision",
              "Inj.Pan 40mg IV/ Inj.Emeset 4mg IV Before shifting",
              "Proctolytics enema needed/Not needed",
              "CTG on admission and before shifting to theatre",
              "Cross match blood- 1UNIT PRBCS Reserve/ On table",
              "Aadhar Card/ ID proof of patient",
            ].map((ele,ind)=>{
              return(
                <h6>{ind+1}) {ele}</h6>
              )
            })}
          </div>

<div style={{ marginTop: "10px" }}>
{renderReportfield("Next Appointment : ",appointmentData.date?.split("-").reverse().join("-"))}
</div>
<p class="Dani"></p>
<PrescriptionFooter/>
        </div>
      </div>
    </>
  );
}
